import styled from 'styled-components';
import { Grid } from '@mantine/core';

const WeekDatesHeaderWrapper = styled.div`
  background: #fff;
  position: sticky;
  top: 84px;
  z-index: 50;
  padding-top: 20px;
  margin-right: 1rem;

  @media only screen and (max-width: 1023px) {
    padding: 0px 10px;
  }

  @media only screen and (max-width: 769px) {
    padding: 0px 20px;
    margin-right: -10px;
    margin-left: -10px;
  }
`;

const WeekDatesHeaderRow = styled(Grid)`
  font-weight: 600;
  color: #212529;
`;

const WeekDatesRow = styled(Grid)`
  margin-top: -3px !important;

  & + div {
    margin-top: .5rem;
  }
`;

export {
  WeekDatesHeaderWrapper,
  WeekDatesRow,
  WeekDatesHeaderRow,
};